import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {
  slackUrl: string;
  constructor() {}

  ngOnInit() {
    this.slackUrl = environment.slackurl;
  }
}
